import CollapseMod from './collapse.js';
var MODULE_NAME = 'ui.bootstrap.module.collapse';
let compMod = angular.module(MODULE_NAME, [CollapseMod]);
export default compMod = compMod.name;
